import { ComponentStyleConfig } from "@chakra-ui/react";
import { theme as chakraTheme } from "@chakra-ui/theme";

const DrawerTheme: ComponentStyleConfig = {
  variants: {
    floating: {
      dialog: {
        pointerEvents: "auto",
        margin: "72px 8px 8px 8px",
        borderRadius: 8,
      },
      header: {
        "&&": {
          textStyle: "h4",
        },
        padding: "24px",
      },
      body: {
        py: 0,
      },
      closeButton: {
        top: "16px",
        right: "16px",
      },
    },
  },
  sizes: {
    md: (props) => {
      if (props.variant === "floating") {
        return {
          dialog: {
            maxWidth: "400px",
          },
        };
      }
      return {};
    },
    editor: (props) => {
      if (props.variant === "floating") {
        return {
          dialog: {
            maxWidth: "504px",
          },
        };
      }
      return {};
    },
    lg: (props) => {
      if (props.variant === "floating") {
        return {
          dialog: {
            maxWidth: "700px",
          },
        };
      }
      return {};
    },
  },
  parts: chakraTheme.components.Drawer.parts,
};

export default DrawerTheme;
